module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch25"
    }
  }, [_c('b', [_vm._v("What’s in a Name?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Most popular names for U.S. high school sports teams: Eagles and Tigers.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The troll dolls of the 1960s were also known as Dam Dolls, after their creator, Thomas Dam.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first Atlantic storm to carry a man’s name was Hurricane Bob (1979). (Before that, they were all named after women.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The O’ prefix in Irish surnames means “grandson of.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Babe Ruth’s residence in Sudbury, Massachusetts, was named Home Plate Farm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("There are approximately 600 different surnames in China but more than a million in the United States.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Author Douglas Adams ("), _c('i', [_vm._v("The Hitchhiker’s Guide to the Galaxy")]), _vm._v(") chose the name of Pink Floyd’s 1994 album "), _c('i', [_vm._v("The Division Bell")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("To enter the Bob Jones Open golf tournament, you must be named Bob Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The world’s most common name: Muhammad.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("According to some studies, the surname Baer has the most spelling variations—36. Snyder is second with 29, and Bailey has 22. (But these are the most common spellings.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Malcolm X named his first daughter, Attalah, after Attila the Hun.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Miss Ima Hogg, the “First Lady of Texas,” was a beloved philanthropist and patron of the arts.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Pete Townshend and John Entwistle of the Who played in a Dixieland band called the Confederates.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("According to legend, Paul Bunyan’s cook was named Hot Biscuit Slim.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b38b026a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter25.vue
// module id = 147
// module chunks = 0